/* eslint-disable */
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled, { withTheme } from 'styled-components'
import Icon from '../../components/common/Icon'
import Price from '../../components/exchange/Price'
import { calPrice } from '../../utils/number'

const Wrapper = styled.div`
  height: 30px;
  line-height: 30px;
  display: flex;
  flex-direction: row;
  font-size: 20px;
  background: ${({ theme }) => theme.exchangeFilterBg};
  padding: 0 5px;
  justify-content: flex-start;
  cursor: pointer;
  font-weight: bold;
`

const Current = styled.div`
  color: ${({ theme }) => theme.highlight};
  font-size: 16px;
  margin-left: 20px;
`

class CurrentPrice extends PureComponent {
  static propTypes = {
    trade: PropTypes.object,
    cryptoCurrencyRate: PropTypes.object,
    tickerSize: PropTypes.object.isRequired,
    xBNBSymbol: PropTypes.object,
    dispatch: PropTypes.func,
  }

  static defaultProps = {
    trade: {},
    cryptoCurrencyRate: {},
    xBNBSymbol: null,
    dispatch: () => {},
  }

  constructor(props) {
    super(props)
    this.state = {
      type: 'rise',
    }
  }

  componentDidUpdate(nextProps) {
    const { trade } = this.props
    const newPrice = nextProps.trade.p ? parseFloat(nextProps.trade.p) : 0
    const oldPrice = trade.p ? parseFloat(trade.p) : 0
    if (newPrice === oldPrice) return
    if (newPrice > oldPrice) {
      this.setState({ type: 'drop' })
    } else {
      this.setState({ type: 'rise' })
    }
  }

  _usdPrice = (cryptoCurrencyRate, key, lastPrice) => {
    const { xBNBSymbol, trade } = this.props
    lastPrice = parseFloat(lastPrice, 10)
    if (cryptoCurrencyRate[key] && !trade.quoteAsset.includes('USDT')) {
      return `$${calPrice(lastPrice * cryptoCurrencyRate[key])}`
    }

    if (!xBNBSymbol) return ''

    return `$${calPrice(
      parseFloat(1 / xBNBSymbol.price, 10) * lastPrice * cryptoCurrencyRate.BNB_USDT
    )}`
  }

  render() {
    const { trade, cryptoCurrencyRate, tickerSize, theme } = this.props
    const { type } = this.state
    const quotaAsset = trade.quoteAsset && trade.quoteAsset.replace(/[\.-].+/, '')
    const key = Object.keys(cryptoCurrencyRate).find(c => c.includes(quotaAsset))
    const price = trade.price
    const usdPrice = this._usdPrice(cryptoCurrencyRate, key, price)
    return (
      <Wrapper>
        <Price
          value={price}
          canSetPrice={true}
          tickerSize={tickerSize}
          priceColor={type === 'rise' ? theme.up : theme.down}
        />
        {price && <Icon type={type} size={14} color={type === 'rise' ? theme.up : theme.down} />}
        <Current>{usdPrice}</Current>
      </Wrapper>
    )
  }
}

const mapStateToProps = ({
  exchange: { cryptoCurrencyRate },
  tickers: { symbolTickers, tickerSize },
  trade: { tradeHistory },
}) => {
  const trade = (tradeHistory && tradeHistory.trade[0]) || {}
  const xBNBSymbol = symbolTickers.find(st => st.symbol === `BNB_${trade.quoteAsset}`)
  return {
    trade,
    cryptoCurrencyRate,
    xBNBSymbol,
    tickerSize,
  }
}

export default connect(mapStateToProps)(withTheme(CurrentPrice))
